import { Link } from "react-router-dom";
import { FiPackage } from "react-icons/fi";
import { ROUTES } from "@/routes/paths";
import { getPlacedOrders } from "../lib/placedOrders";

/**
 * Orders placed from THIS browser.
 *
 * There are no accounts, so this list comes from local storage rather than the
 * server — the server has no way to know who is asking. Anything placed on
 * another device is reached through the link in the confirmation email.
 */
export function OrdersPage() {
  const orders = getPlacedOrders();

  return (
    <div className="mx-auto max-w-2xl">
      <h1 className="mb-2 text-2xl font-bold text-foreground">My orders</h1>
      <p className="mb-6 text-sm text-muted-foreground">
        Orders you placed on this device. Used a different phone or computer? Open the
        link in your confirmation email.
      </p>

      {orders.length === 0 ? (
        <div className="rounded-lg border border-dashed border-border p-8 text-center">
          <FiPackage className="mx-auto mb-3 text-muted-foreground" size={28} />
          <p className="mb-4 text-muted-foreground">No orders from this device yet.</p>
          <Link to={ROUTES.PRODUCTS} className="text-primary hover:underline">
            Browse products
          </Link>
        </div>
      ) : (
        <ul className="space-y-3">
          {orders.map((o) => (
            <li
              key={o.token}
              className="rounded-lg border border-border bg-card text-card-foreground"
            >
              <Link
                to={o.kind === "custom-order" ? ROUTES.TRACK_CUSTOM(o.token) : ROUTES.TRACK(o.token)}
                className="flex items-center justify-between gap-3 p-4 hover:bg-secondary"
              >
                <span className="min-w-0">
                  <span className="block font-medium text-foreground">
                    {o.orderNumber || "Order"}
                  </span>
                  <span className="block truncate text-sm text-muted-foreground">
                    {o.title || (o.kind === "custom-order" ? "Custom order" : "Order")}
                  </span>
                </span>
                <span className="shrink-0 text-xs text-muted-foreground">
                  {new Date(o.placedAt).toLocaleDateString()}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default OrdersPage;
